import { RevenueStatisticsScreenNavigationProps } from "./types"
import React from "react"
import RevenueStatistics from "./revenue-statistics-screen"
import { PageRoot } from "~screens/page-root"


const RevenueStatisticsScreen: React.FC<RevenueStatisticsScreenNavigationProps> = (props) => {
  return (
    <PageRoot>
      <RevenueStatistics route={props.route}/>
    </PageRoot>
  )
}

export default RevenueStatisticsScreen
